import React, { useEffect, useState } from 'react'
import DropdownContainer from '../dropdown'
import { ChartImage, CouncilDesktop, CouncilMobile, HousingAssociateDesktop, HousingAssociateMobile, LandlordDesktop, LandlordMobile, LettingAgentDesktop, LettingAgentMobile, DemoSteps, DemoStepsMobile } from '../../config/images';
import { Link } from 'react-router-dom';

const Chart = (props) => {

  const chartData = [{
    id: "1",
    category: 'Housing association',
    img: HousingAssociateDesktop,
    imgMobile: HousingAssociateMobile

  }, {
    id: "2",
    category: 'Council',
    img: CouncilDesktop,
    imgMobile: CouncilMobile

  }, {
    id: "3",
    category: 'Letting agent',
    img: LettingAgentDesktop,
    imgMobile: LettingAgentMobile

  }, {
    id: "4",
    category: 'Private landlord',
    img: LandlordDesktop,
    imgMobile: LandlordMobile,

  }


  ]

  const [dropdownVal, setDropDownVal] = useState();
  const [dropdDownId, setDropDownId] = useState("4");
  const [chartImage, setChartImage] = useState('');
  const [mobileImage, setmMobileImage] = useState('');

  const onDropDownClick = (val, id) => {
    setDropDownVal(val);
    setDropDownId(id);
  }


  useEffect(() => {
    const filter = chartData.filter((item) => item.id === dropdDownId);
    setChartImage(filter[0].img);
    setmMobileImage(filter[0].imgMobile)
  }, [dropdDownId])


  return (
    <div className='chart bg-light '>
      <div className='container'>
        {/* <h3 className='title lightGrey'>{props?.title}</h3>
        <DropdownContainer title={'I’m renting with'} colorClass={'bg-white'} color="lightBlue" dropdownvalue={dropdownVal ? dropdownVal : props.dropdown['3']?.value} options={props.dropdown} onDropDownChange={onDropDownClick} />
        <img src={chartImage} alt={dropdownVal} className='chart-image d-none d-md-block' />
        <div className='chart-mobile-container'>
          <img src={mobileImage} alt={dropdownVal} className='chart-image d-block d-md-none' />
        </div> */}
        <div className='content-container  d-flex justify-content-between' >
          <div className='sub-content-container bg-white'>
            <h2 className='title card-title'>{props?.title}</h2>
            {/* <p className='description text-normal darkGrey inter-font'>{props?.personal_description}</p> */}
            <ol className="step-list" aria-label="How it works steps">
            {props?.howItWorkPoints?.map((point, idx) => (
            <li key={idx} className="step-item">
             <div className="step-number" aria-hidden="true">{idx + 1}</div>
             <div className="step-text">{point}</div>
            </li>
            ))}

           
           </ol>
            <Link className="button" to="/get-advice/questions" aria-label="Get started with housing questions">Get started now</Link>
          </div>
          <div className="additional-container">
            <img src={DemoSteps} alt="Visual illustration of the how it works process steps" className="demo-image d-none d-md-block" />
            <img src={DemoStepsMobile} alt="Visual illustration of the how it works process steps" className="demo-image d-block d-md-none" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Chart
